import { render, staticRenderFns } from "./CommissionBalances.vue?vue&type=template&id=4d109e79&scoped=true&"
import script from "./CommissionBalances.vue?vue&type=script&lang=js&"
export * from "./CommissionBalances.vue?vue&type=script&lang=js&"
import style0 from "./CommissionBalances.vue?vue&type=style&index=0&id=4d109e79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d109e79",
  null
  
)

export default component.exports